export const FETCH_KITCHEN_DISHES = "FETCH_KITCHEN_DISHES";
export const FETCH_KITCHEN_DISHES_SUCCESS = "FETCH_KITCHEN_DISHES_SUCCESS";
export const FETCH_KITCHEN_DISHES_FAILURE = "FETCH_KITCHEN_DISHES_FAILURE";

export const SAVE_KITCHEN_DISH = "SAVE_KITCHEN_DISH";
export const DELETE_KITCHEN_DISH = "DELETE_KITCHEN_DISH";

export const FETCH_KITCHEN_MENUS = "FETCH_KITCHEN_MENUS";
export const FETCH_KITCHEN_MENUS_SUCCESS = "FETCH_KITCHEN_MENUS_SUCCESS";
export const FETCH_KITCHEN_MENUS_FAILURE = "FETCH_KITCHEN_MENUS_FAILURE";

export const SAVE_KITCHEN_MENU = "SAVE_KITCHEN_MENU";
export const PUBLISH_KITCHEN_MENU = "PUBLISH_KITCHEN_MENU";
export const UNPUBLISH_KITCHEN_MENU = "UNPUBLISH_KITCHEN_MENU";

// Dish photos + ✦ Tidy (wave 2, 29 Sep 2026). Callback-driven: the dish editor
// owns the photo state, so none of these touch the reducer.
export const FETCH_KITCHEN_DISH = "FETCH_KITCHEN_DISH";
export const FETCH_DISH_PHOTO_LIBRARY = "FETCH_DISH_PHOTO_LIBRARY";
export const UPLOAD_DISH_PHOTO = "UPLOAD_DISH_PHOTO";
export const ATTACH_DISH_PHOTO = "ATTACH_DISH_PHOTO";
export const UPDATE_DISH_PHOTO = "UPDATE_DISH_PHOTO";
export const DELETE_DISH_PHOTO = "DELETE_DISH_PHOTO";
export const POLISH_DISH_PHOTO = "POLISH_DISH_PHOTO";
export const TIDY_DISH_DESCRIPTION = "TIDY_DISH_DESCRIPTION";

// Meal times per home (wave 3, 30 Sep 2026). `mealSittings` is cached per
// location in this slice; the fetch is shared by every kitchen screen.
export const FETCH_MEAL_SITTINGS = "FETCH_MEAL_SITTINGS";
export const FETCH_MEAL_SITTINGS_SUCCESS = "FETCH_MEAL_SITTINGS_SUCCESS";
export const FETCH_MEAL_SITTINGS_FAILURE = "FETCH_MEAL_SITTINGS_FAILURE";
export const SAVE_MEAL_SITTINGS = "SAVE_MEAL_SITTINGS";
